<div [class.logo--whitelabel]="environmentService.isWhiteLabel" class="logo">
  @if (environmentService.isWhiteLabel) {
    <img role="presentation" alt="" src="./assets/logo.svg" />
  }
  @if (environmentService.isRoyalCanin) {
    <img
      role="presentation"
      alt=""
      src="https://dl.royalcanin.com/8-12-1/logo--primary.svg"
    />
  }
</div>
